import { BaseUrl } from "./BaseUrl";

export const getMediaUrl = (path) => path ? `${BaseUrl}${path}` : undefined;
